// extracted by mini-css-extract-plugin
export var carouselitemcontainer = "SuccessStoriesCarouselItem-module--carouselitemcontainer--aee8c";
export var date = "SuccessStoriesCarouselItem-module--date--f51e6";
export var dogname = "SuccessStoriesCarouselItem-module--dogname--436f5";
export var image = "SuccessStoriesCarouselItem-module--image--a6e89";
export var text = "SuccessStoriesCarouselItem-module--text--2adb6";
export var title = "SuccessStoriesCarouselItem-module--title--43b0b";